import {type FC, useEffect} from 'react';
import {ResponsiveModal} from '~library/organisms/ResponsiveModal';

interface ConfirmLeaveModalContainerProps {
  isFirstStep: boolean;
  isGuestStep: boolean;
  isEditingFlow: boolean;
  isPristine: boolean;
  cancelLeave: () => void;
  saveAndLeave: () => void;
  leave: () => void;
}

export const ConfirmLeaveModalContainer: FC<ConfirmLeaveModalContainerProps> = ({
  isFirstStep,
  isGuestStep,
  isEditingFlow,
  isPristine,
  cancelLeave,
  saveAndLeave,
  leave,
}) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  useEffect(() => {
    if (isPristine && isFirstStep) {
      leave();
    }
    // we only want this check to run on mount
  }, []);

  switch (true) {
    case isPristine && isFirstStep:
      return null;
    case isFirstStep && isEditingFlow:
    case isEditingFlow:
      // this case is in use as of 12/10/2024
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title={isGuestStep ? 'Save & exit?' : 'Are you sure you want to exit?'}
          body={
            isGuestStep
              ? 'Your changes will be saved. Invitations will not be sent yet.'
              : 'Your unsaved changes to this Invitation will be lost.'
          }
          secondaryAction={cancelLeave}
          secondaryText={isGuestStep ? 'Continue working' : 'No'}
          primaryAction={leave}
          primaryText={isGuestStep ? 'Save & exit' : 'Yes'}
          primaryQaId="modal-add-guests-exit-submit"
          secondaryQaId="modal-add-guests-exit-cancel"
          closeQaId="modal-add-guests-exit-close"
        />
      );
    case isFirstStep:
      // step 1
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title="Are you sure you want to exit?"
          body="You will lose your invitation progress. Please continue to Step 2 to save your invitation."
          secondaryAction={leave}
          secondaryText="Yes, I'll exit"
          primaryAction={cancelLeave}
          primaryText="No, I'll continue"
          titleQaId="createFlowUpsellModalLabel"
          bodyQaId="createFlowUpsellModalDescription"
          secondaryQaId="say-yes-btn"
          secondaryImpressionTracking
        />
      );
    default:
      // step 2, 3, 4
      return (
        <ResponsiveModal
          isOpen
          onClose={cancelLeave}
          title="Exit the Invitation Editor"
          body="We've saved your progress so you can finish creating your invitation later."
          secondaryAction={cancelLeave}
          secondaryText="Keep Editing"
          primaryAction={saveAndLeave}
          primaryText="Exit"
          titleQaId="createFlowUpsellModalLabel"
          bodyQaId="createFlowUpsellModalDescription"
          secondaryQaId="keep-editing-btn"
          primaryQaId="exit-btn"
          primaryImpressionTracking
        />
      );
  }
};
